import { PageType } from "shared/lib/page-type";

export const pathname = "/plus/cft";

export const page = {
  route(query: QueryParameters<{ nodeId?: string }>) {
    return { pathname, query: { ...query, pageType: PageType.Plus } };
  },
};
